import React, { ReactNode } from 'react';

import classnames from 'classnames';
import { styled } from '@mui/material/styles';

import { Color } from '../../theme';

type Props = {
  className?: string;
  href?: string;
  children: ReactNode;
  variant: 'full' | 'outline';
};

export const Button = styled(
  ({ className, href, children, variant }: Props) => (
    <a className={classnames('Button', variant, className)} href={href}>
      {children}
    </a>
  )
)<Props>`
  &:link,
  &:visited {
    color: ${Color.green};
    text-decoration: none;
    padding-bottom: 1px;
    border-bottom: 1px solid transparent;
  }

  &:hover,
  &:active {
    color: ${Color.green};
    border-bottom: 1px solid ${Color.green};
    transition: border-bottom 0.2s, color 0.2s;
  }

  &:link,
  &:visited,
  input[type='submit'] {
    display: inline-block;
    padding: 10px 30px;
    text-decoration: none;
    border-radius: 100px;
    color: ${Color.black};
    transition: background-color 0.2s, border 0.2s, color 0.2s;
  }

  &.full:link,
  &.full:visited,
  input[type='submit'] {
    background-color: ${Color.green};
    border: 1px solid ${Color.green};
    margin-right: 16px;
  }

  &.outline:link,
  &.outline:visited {
    color: ${Color.green};
    border: 1px solid ${Color.green};
  }

  :hover,
  :active,
  input[type='submit']:hover,
  input[type='submit']:active {
    background-color: ${Color.greenDarker};
  }

  &.full:hover,
  &.full:active,
  input[type='submit'] {
    color: ${Color.white};
    border: 1px solid ${Color.greenDarker};
    background-color: ${Color.greenDarker};
  }

  &.outline:hover,
  &.outline:active {
    color: ${Color.white};
    border: 1px solid ${Color.greenDarker};
  }
`;
